import { Component, TemplateRef, ViewChild, ElementRef } from '@angular/core';
import { LoaderComponent } from '../../../components/layout/loader/loader.component';
import { CommonModule } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiService } from '../../../services/api.service';
import { ModalDismissReasons, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ProductFormComponent } from '../../../components/product/product-form/product-form.component';
import { ConfirmDeleteComponent } from '../../../components/confirm-delete/confirm-delete.component';

import { CdkDragDrop, CdkDropList, CdkDrag, moveItemInArray } from '@angular/cdk/drag-drop';
import { ImagePreviewComponent } from '../../../components/image-preview/image-preview.component';
import { ChapterFormComponent } from '../../../components/product/details/chapter-form/chapter-form.component';

import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-product-detail',
  standalone: true,
  imports: [
    CommonModule,
    LoaderComponent,
    CdkDropList,
    CdkDrag,
    FormsModule
  ],
  templateUrl: './product-detail.component.html',
  styleUrl: './product-detail.component.scss'
})
export class ProductDetailComponent {
  @ViewChild('fileInput') fileInput: ElementRef | null = null;

  loading: boolean = false;
  item: any | null = null;

  productStudyLevels: [] | null = [];
  productSubjects: [] | null = [];
  productCourses: any[] | null = [];
  productChapters: [] | null = [];
  productAuthors: [] | null = [];
  productImages: [] | null = [];

  studyLevels: [] | null = [];
  subjects: [] | null = [];
  courses: [] | null = [];
  authors: [] | null = [];

  selectedMethode: any = '';
  courseSections: any[] = [];

  private modalRef: NgbModalRef | null = null; // Store modal reference

  constructor(
    private modalService: NgbModal,
    private activatedRoute: ActivatedRoute,
    private apiService: ApiService
  ) {
    this.loading = true;
    this.reload();
  }

  drop(event: CdkDragDrop<string[]>) {
    const self = this;

    if (self.productImages !== null && self.productImages.length > 1) {
      moveItemInArray(self.productImages, event.previousIndex, event.currentIndex);

      const updatePromises = self.productImages.map((image, index) =>
        this.updateImagePosition(image, index)
      );

      Promise.all(updatePromises).then(() => {
        self.reloadProduct();
      }).catch((error) => {
        console.error("Error updating image positions:", error);
      });
    }
  }

  triggerFileInput() {
    if (this.fileInput) {
      this.fileInput.nativeElement.click();
    }
  }

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      this.uploadImage(this.item, file);
    }
  }

  addRelation(content: TemplateRef<any>) {
    let self = this;
    this.modalRef = this.modalService.open(content, {
      size: 'lg',
      ariaLabelledBy: 'modal-basic-title'
    });
    this.modalRef.result.then(
      (result) => {

      },
      (reason) => {

      },
    );
  }

  addModule() {
    const modalRef = this.modalService.open(ChapterFormComponent, { size: 'lg' });
    modalRef.componentInstance.modalStyle = true;
    modalRef.componentInstance.productSubjects = this.courses;

    if (this.productCourses?.length === 1) {
      modalRef.componentInstance.selectedSubjectId = this.productCourses[0].id;
    }

    modalRef.componentInstance.productId = this.activatedRoute.snapshot.paramMap.get('id');
    modalRef.result.then((result) => {
      this.reload();
    });
  }

  reload() {
    this.reloadProduct();
    this.loadSettings();
  }

  selectedStudyLevels: any[] = []; // Array to store selected study levels
  currentStudyLevels: any[] = [];

  // Add or remove study levels from the selected list
  onCheckboxChange(event: any) {
    const studyLevel = event.target.value;
    if (event.target.checked) {
      this.selectedStudyLevels.push(studyLevel);
    } else {
      this.selectedStudyLevels = this.selectedStudyLevels.filter(
        (level) => level.id !== studyLevel.id
      );
    }
  }

  // Check if the study level is already selected
  isStudyLevelSelected(studyLevel: any): boolean {
    return this.currentStudyLevels.some(
      (current: any) => current.id === studyLevel.id
    ); // Adjust `currentStudyLevels` to the list of already selected levels
  }

  // Submit selected study levels
  submitSelectedStudyLevels(item: any) {
    console.log(this.selectedStudyLevels)
    const promises = this.selectedStudyLevels.map((studyLevel) =>
      this.apiService.post(`/office/products/${item['id']}/study-levels`, {
        studyLevelId: studyLevel,
      })
    );

    Promise.all(promises).then(() => {
      this.reloadProduct();
      this.selectedStudyLevels = []; // Clear selected study levels
      if (this.modalRef) {
        this.modalRef.close();
        this.modalRef = null;
      }
    });
  }


  loadSettings() {
    let self = this;
    this.apiService.get('/office/study-levels?limit=999&sort=name&order=asc').then(function (response: any) {
      self.studyLevels = response['data'];
    });
    this.apiService.get('/office/courses?limit=999&sort=title&order=asc').then(function (response: any) {
      self.courses = response['data'];
    });
    this.apiService.get('/office/authors?limit=999&sort=name&order=asc').then(function (response: any) {
      self.authors = response['data'];
    });
    this.apiService.get('/office/subjects?limit=999&sort=name&order=asc').then(function (response: any) {
      self.subjects = response['data'];
    });
  }

  removeStudyLevel(item: any, studyLevel: any) {
    let self = this;
    return this.apiService.delete('/office/products/' + item['id'] + '/study-levels/' + studyLevel['id']).then(function (response: any) {
      self.reloadProduct();
    });
  }

  removeCourse(item: any, course: any) {
    let self = this;
    return this.apiService.delete('/office/products/' + item['id'] + '/courses/' + course['id']).then(function (response: any) {
      self.reloadProduct();
    });
  }

  removeChapter(item: any, chapter: any) {
    let self = this;
    return this.apiService.delete('/office/products/' + item['id'] + '/chapters/' + chapter['id']).then(function (response: any) {
      self.reloadProduct();
    });
  }

  removeSubject(item: any, subject: any) {
    let self = this;
    return this.apiService.delete('/office/products/' + item['id'] + '/subjects/' + subject['id']).then(function (response: any) {
      self.reloadProduct();
    });
  }

  removeAuthor(item: any, author: any) {
    let self = this;
    return this.apiService.delete('/office/products/' + item['id'] + '/authors/' + author['id']).then(function (response: any) {
      self.reloadProduct();
    });
  }

  removeImage(image: any) {
    let self = this;

    self.loading = false;
    const deleteModal = this.modalService.open(ConfirmDeleteComponent);
    deleteModal.componentInstance.message = 'Weet je zeker dat je wilt verwijderen?';
    deleteModal.result.then((result): any => {
      if (result) {
        let self = this;
        return this.apiService.delete('/office/products/' + self.item['id'] + '/images/' + image['id']).then(function (response: any) {
          self.reloadProduct();
        });
      } else {
        return true;
      }
    });

  }

  addStudyLevel(item: any, studyLevel: any) {
    let self = this;
    return this.apiService.post('/office/products/' + item['id'] + '/study-levels', {
      studyLevelId: studyLevel['id']
    }).then(function (response: any) {
      self.reloadProduct();
      if (self.modalRef) {
        self.modalRef.close();
        self.modalRef = null;
      }
    });
  }

  addCourse(item: any, course: any) {
    let self = this;
    return this.apiService.post('/office/products/' + item['id'] + '/courses', {
      courseId: course['id']
    }).then(function (response: any) {
      self.reloadProduct();
      if (self.modalRef) {
        self.modalRef.close();
        self.modalRef = null;
      }
    });
  }

  addSubject(item: any, subject: any) {
    let self = this;
    return this.apiService.post('/office/products/' + item['id'] + '/subjects', {
      subjectId: subject['id']
    }).then(function (response: any) {
      self.reloadProduct();
      if (self.modalRef) {
        self.modalRef.close();
        self.modalRef = null;
      }
    });
  }

  addAuthor(item: any, author: any) {
    let self = this;
    return this.apiService.post('/office/products/' + item['id'] + '/authors', {
      authorId: author['id']
    }).then(function (response: any) {
      self.reloadProduct();
      if (self.modalRef) {
        self.modalRef.close();
        self.modalRef = null;
      }
    });
  }

  uploadImage(item: any, file: any) {
    let self = this;
    return this.apiService.post('/office/products/' + item['id'] + '/images', {
      file: file
    }).then(function (response: any) {
      self.reloadProduct();
    });
  }

  updateImagePosition(item: any, position: number) {
    return this.apiService.put('/office/products/images/' + item['id'], {
      position: position
    });
  }

  openImagePreview(imageId: string) {
    const url = this.productIdToUrl(imageId);

    const previewModal = this.modalService.open(ImagePreviewComponent, {
      size: 'xl',
    });
    previewModal.componentInstance.imageUrl = url;
    previewModal.result.then((result): any => {
    });
  }

  reloadProduct() {
    this.loading = true;
    this.getProduct();
    this.getProductStudyLevels();
    this.getProductCourses();
    this.getProductSubjects();
    this.getProductAuthors();
    this.getProductImages();
    this.getProductChapters();
  }

  getProductStudyLevels() {
    let itemId = this.activatedRoute.snapshot.paramMap.get('id');
    let self = this;
    return this.apiService.get('/office/products/' + itemId + '/study-levels').then(function (response: any) {
      self.productStudyLevels = response;
    }).catch(function (e) {
    });
  }

  getProductCourses() {
    let itemId = this.activatedRoute.snapshot.paramMap.get('id');
    let self = this;
    return this.apiService.get('/office/products/' + itemId + '/courses').then(function (response: any) {
      self.productCourses = response;
    }).catch(function (e) {
    });
  }

  getProductChapters() {
    let itemId = this.activatedRoute.snapshot.paramMap.get('id');
    let self = this;
    return this.apiService.get('/office/products/' + itemId + '/chapters').then(function (response: any) {
      self.productChapters = response;
    }).catch(function (e) {
    });
  }

  getProductSubjects() {
    let itemId = this.activatedRoute.snapshot.paramMap.get('id');
    let self = this;
    return this.apiService.get('/office/products/' + itemId + '/subjects').then(function (response: any) {
      self.productSubjects = response;
    }).catch(function (e) {
    });
  }

  getProductAuthors() {
    let itemId = this.activatedRoute.snapshot.paramMap.get('id');
    let self = this;
    return this.apiService.get('/office/products/' + itemId + '/authors').then(function (response: any) {
      self.productAuthors = response;
    }).catch(function (e) {
    });
  }

  getProductImages() {
    let itemId = this.activatedRoute.snapshot.paramMap.get('id');
    let self = this;
    return this.apiService.get('/office/products/' + itemId + '/images').then(function (response: any) {
      self.productImages = response;
    }).catch(function (e) {
    });
  }

  productIdToUrl(id: string) {
    return this.apiService.getApiBaseURL() + '/office/products/' + this.item['id'] + '/images/' + id + '/view';
  }

  openModal(item: any) {
    let self = this;
    const modalRef = this.modalService.open(ProductFormComponent, {
      size: 'lg'
    });
    modalRef.componentInstance.modalStyle = true;

    let updated_item = item;
    if (updated_item.first_published_date) {
      updated_item.first_published_date = updated_item.first_published_date.replace(" 00:00:00", "");
    }
    if (updated_item.created_at) {
      updated_item.created_at = updated_item.created_at.replace(" 00:00:00", "");
    }

    modalRef.componentInstance.item = updated_item;
    modalRef.result.then((result) => {
      self.getProduct();
    });
  }

  getProduct() {
    let itemId = this.activatedRoute.snapshot.paramMap.get('id');
    let self = this;
    return this.apiService.get('/office/products/' + itemId).then(function (response: any) {
      self.item = response;
      setTimeout(function () { self.loading = false; }, 200);
    }).catch(function (e) {
      self.loading = false;
    });
  }
}
